
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("io2Oj", function(module, exports) {

$parcel$export(module.exports, "CARDS_DEFAULT_UNSPLASH_QUERY_WORD", () => $14315e87514432fd$export$1350d32d25baa8ae);
$parcel$export(module.exports, "PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD", () => $14315e87514432fd$export$4eb66a6321d4a29c);
$parcel$export(module.exports, "UnsplashSearchContent", () => $14315e87514432fd$export$dab0686b1ddf2c98);
/* UnsplashSearchContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $9YwaJ = parcelRequire("9YwaJ");

var $gj7hi = parcelRequire("gj7hi");

var $inPa6 = parcelRequire("inPa6");

var $9Ek9W = parcelRequire("9Ek9W");

var $26cuJ = parcelRequire("26cuJ");
const $14315e87514432fd$export$1350d32d25baa8ae = 'pastel gradient';
const $14315e87514432fd$export$4eb66a6321d4a29c = 'color';
const $14315e87514432fd$var$UNSPLASH_LICENSE_LINK = 'https://unsplash.com/license';
const $14315e87514432fd$var$UNSPLASH_TERMS_OF_SERVICE_LINK = 'https://unsplash.com/terms';
const $14315e87514432fd$var$i18n = (0, $2nPZH.defineMessages)({
    unsplashNoResultsText: {
        id: "custom-sites-extensions.unsplash.search.no.results.text",
        defaultMessage: "Nothing matches your search"
    },
    unsplashNoMoreResultsToLoadText: {
        id: "custom-sites-extensions.unsplash.search.no.more.results.to.load.text",
        defaultMessage: "No more matches try another search"
    },
    unsplashLegal: {
        id: "custom-sites-extensions.unsplash.legal",
        defaultMessage: "By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}."
    },
    unsplashLicenseLink: {
        id: "custom-sites-extensions.unsplash.license",
        defaultMessage: "license"
    },
    unsplashTermsOfServiceLink: {
        id: "custom-sites-extensions.unsplash.terms.of.service.",
        defaultMessage: "Terms of Service"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14315e87514432fd$var$SearchContentContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_p12f1d1q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14315e87514432fd$var$SearchResultsContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15zi _18m915zi _zulpu2gc _1yt4u2gc _1e0c11p5 _c71l1sa4 _yv0e1d08",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$UnsplashWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1n7u _kqswh2mm _1bsb6ci3",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$artistInfoSelector = 'link-cards.ArtistInfo';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14315e87514432fd$var$ArtistInfo = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11q7mpja _11c81o8v _mrkb1l7b _1o0z1l7b _kqswstnw _94n5idpf _1bsb1osq _tzy4kb7n _3um015vq _ak06ewfl",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$ArtistLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4bfu1r81 _1hmsagmp _ajmmvv82",
            __cmplp.className
        ])
    });
});
$14315e87514432fd$var$ArtistInfo.defaultProps = {
    'data-styled-selector': $14315e87514432fd$var$artistInfoSelector
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14315e87514432fd$var$ArtistNameWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _18u01b66 _syaz15cr _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$baseImageStyles = {
    width: '100%',
    height: '77.93px',
    borderRadius: '3px'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14315e87514432fd$var$UnsplashImage = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _1bsb1osq _4t3i1r1e",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$UnsplashImageWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itglyw _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _4t3i1r1e _12jiz4b0 _1nt9ewfl",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$UnsplashLegalTerms = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41bpf _11c81o8v _bfhk11bn _mrkb1l7b _1o0z1l7b _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$LegalTextWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s816r1",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$UnderlinedLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4bfu18uv _1hms8stv _ajmmnqa1 _syazpf9b",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$EndofResultsWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o _1461g31l",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$UnsplashSearchErrorWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulppxbi _yyhyuojk _1e0c1txw _4t3i1jje _2lx21bp4 _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$SearchErrorText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$ImagePlaceholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _1bsb1osq _4t3i1r1e _bfhkm7j4",
            __cmplp.className
        ])
    });
});
const $14315e87514432fd$var$UnsplashLicenseLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnderlinedLink, {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $14315e87514432fd$var$i18n.unsplashLicenseLink));
const $14315e87514432fd$var$UnsplashTermsOfServiceLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnderlinedLink, {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $14315e87514432fd$var$i18n.unsplashTermsOfServiceLink));
const $14315e87514432fd$export$dab0686b1ddf2c98 = ({ unSplashSearchResults: unSplashSearchResults, idPrefix: idPrefix, handleImageSelection: handleImageSelection, loadMoreText: loadMoreText, queryWord: queryWord, pageNumber: pageNumber, setUnsplashSearchResults: setUnsplashSearchResults, handleError: handleError, searchResultsRef: searchResultsRef, unsplashResultsCountFromLastAPICall: unsplashResultsCountFromLastAPICall, setUnsplashResultsCountFromLastAPICall: setUnsplashResultsCountFromLastAPICall, dropdownPopupComponentRef: dropdownPopupComponentRef, isPageTitleComponent: isPageTitleComponent, analyticsSource: analyticsSource })=>{
    const [showButtonSpinner, setShowButtonSpinner] = (0, $gwFzn.useState)(false);
    const imageRef = (0, $gwFzn.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onImageClick = ({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink })=>{
        handleImageSelection({
            fullSizeImageUrl: fullSizeImageUrl,
            altDescription: altDescription,
            downloadLink: downloadLink
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'selected',
                actionSubject: 'image',
                source: analyticsSource,
                attributes: {
                    imageSource: 'unsplashSearch'
                }
            }
        }).fire();
    };
    const onKeyDown = (e, result)=>{
        if (e.key === 'Enter' || e.key === ' ') onImageClick(result);
    };
    const onClickLoadMoreButton = ()=>{
        setShowButtonSpinner(true);
        pageNumber.current++;
        const defaultQueryWord = isPageTitleComponent ? $14315e87514432fd$export$4eb66a6321d4a29c : $14315e87514432fd$export$1350d32d25baa8ae;
        const queryKeyword = queryWord.current || defaultQueryWord;
        (0, $26cuJ.getUnsplashPhotos)(queryKeyword, pageNumber.current, isPageTitleComponent).then((results)=>{
            setUnsplashResultsCountFromLastAPICall(results.length);
            setUnsplashSearchResults(unSplashSearchResults.concat(results));
            setShowButtonSpinner(false);
            imageRef.current?.focus();
        }).catch((error)=>{
            handleError(error);
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'loadMoreUnsplashImagesButtonClicked',
                source: analyticsSource
            }
        }).fire();
    };
    const UnsplashLegalText = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$LegalTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$14315e87514432fd$var$i18n.unsplashLegal,
            values: {
                unsplashLicenseLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashLicenseLink, {
                    link: $14315e87514432fd$var$UNSPLASH_LICENSE_LINK
                }),
                unsplashTermsOfServiceLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashTermsOfServiceLink, {
                    link: $14315e87514432fd$var$UNSPLASH_TERMS_OF_SERVICE_LINK
                })
            }
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$SearchContentContainer, {
        ref: dropdownPopupComponentRef,
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$SearchResultsContainer, {
        ref: searchResultsRef
    }, unSplashSearchResults?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, unSplashSearchResults.map((result, index)=>result ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashWrapper, {
            key: index,
            "data-testid": `${idPrefix}-unsplash-image-${result.id}`,
            onKeyDown: (e)=>onKeyDown(e, result)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashImageWrapper, {
            // assign ref to image result only when it is the first of 30 new images loaded more.
            // This ref is necessary for placing focus on the image result away from load more button
            ref: index === unSplashSearchResults.length - 30 ? imageRef : null,
            onClick: ()=>onImageClick(result)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashImage, {
            src: result.smallSizeImageUrl,
            alt: result.altDescription
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$ArtistInfo, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$ArtistLink, {
            href: result.artistUrl,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$ArtistNameWrapper, null, result.artistName)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$ImagePlaceholder, {
            key: index,
            "data-testid": "unsplash-popup-image-placeholder"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$EndofResultsWrapper, null, unsplashResultsCountFromLastAPICall === 30 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9YwaJ.default), {
        onClick: onClickLoadMoreButton,
        spacing: "compact",
        isLoading: showButtonSpinner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), loadMoreText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$SearchErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $14315e87514432fd$var$i18n.unsplashNoMoreResultsToLoadText)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashSearchErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9Ek9W))),
        alt: "unsplash search no results"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$SearchErrorText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $14315e87514432fd$var$i18n.unsplashNoResultsText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($14315e87514432fd$var$UnsplashLegalTerms, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(UnsplashLegalText, null)));
};

});
parcelRegister("9Ek9W", function(module, exports) {
module.exports = new URL("NoResults.9d75157a.svg", import.meta.url).toString();

});


parcelRegister("4p8wO", function(module, exports) {

$parcel$export(module.exports, "UnsplashSearch", () => $c0180d8c85cbf668$export$7db48b229e0f0751);
/* UnsplashSearch.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $bfgIy = parcelRequire("bfgIy");

var $inPa6 = parcelRequire("inPa6");

var $hw7wB = parcelRequire("hw7wB");

var $1qfLF = parcelRequire("1qfLF");

var $9wGTI = parcelRequire("9wGTI");

var $e78Q2 = parcelRequire("e78Q2");

var $8fqX2 = parcelRequire("8fqX2");

var $bAts8 = parcelRequire("bAts8");

var $aHaJw = parcelRequire("aHaJw");

var $5xYQE = parcelRequire("5xYQE");

var $93SjD = parcelRequire("93SjD");

var $gdToy = parcelRequire("gdToy");
const $c0180d8c85cbf668$var$i18n = (0, $2nPZH.defineMessages)({
    uploadMediaLabel: {
        id: "custom-sites-extensions.unsplash.upload.label",
        defaultMessage: "Upload"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c0180d8c85cbf668$var$UnsplashSearchFlexContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $c0180d8c85cbf668$var$UploadButtonWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_t74o1ylp _11381ylp",
            __cmplp.className
        ])
    });
});
const $c0180d8c85cbf668$var$bottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $c0180d8c85cbf668$var$removeBottomSpacing = (0, $ecnYn.xcss)({
    marginBottom: 'space.0'
});
const $c0180d8c85cbf668$export$7db48b229e0f0751 = ({ id: id, idPrefix: idPrefix, imageAltText: imageAltText, sectionLabel: sectionLabel, helperMessage: helperMessage, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, handleImageSelection: handleImageSelection, openMediaBrowser: openMediaBrowser, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: placement = 'bottom', contentId: contentId, confluencePageId: confluencePageId, analyticsSource: analyticsSource, analyticsActionSubject: analyticsActionSubject, analyticsActionSubjectId: analyticsActionSubjectId, isPageTitleComponent: isPageTitleComponent = false, isUploadingImage: isUploadingImage = false, isNoImageAllowed: isNoImageAllowed, enableBottomSpacing: enableBottomSpacing = true })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isDisabled = (0, $bAts8.useIsDisabledContext)();
    const { selectedDefaultImageUrl: selectedDefaultImageUrl, setDefaultUnsplashResults: setDefaultUnsplashResults, defaultUnsplashResults: defaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError, errorMessage: errorMessage } = (0, $aHaJw.useUnsplash)({
        isPageTitleComponent: isPageTitleComponent,
        selectedImageUrl: selectedImageUrl,
        initialUnsplashResults: initialUnsplashResults
    });
    const unsplashSearchFieldId = id ? `${idPrefix}-search-unsplash-${id}` : `${idPrefix}-search-unsplash`;
    const handleUploadButtonClick = ()=>{
        openMediaBrowser && openMediaBrowser();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: analyticsActionSubject,
                actionSubjectId: analyticsActionSubjectId,
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c0180d8c85cbf668$var$UnsplashSearchFlexContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bfgIy.Label), {
        htmlFor: unsplashSearchFieldId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e78Q2.ConfigPanelSubheading), {
        showUpdatedStyles: (0, $9wGTI.fg)('company_hub_cards_config_updates_v2')
    }, sectionLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $93SjD.MediaContentHelperMessage), {
        helperMessage: helperMessage,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5xYQE.UnsplashSearchBar), {
        unsplashSearchFieldId: unsplashSearchFieldId,
        elementIdPrefix: "link-card",
        handleImageSelection: handleImageSelection,
        analyticsSource: analyticsSource,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setError: setError,
        handleError: handleError,
        placement: placement,
        dropdownPopupComponentRef: dropdownPopupComponentRef,
        isUploadingImage: isUploadingImage
    }), !!openMediaBrowser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c0180d8c85cbf668$var$UploadButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        onClick: handleUploadButtonClick,
        testId: "open-media-browser",
        isDisabled: isUploadingImage || isDisabled,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
                color: "currentColor",
                spacing: "spacious",
                label: intl.formatMessage($c0180d8c85cbf668$var$i18n.uploadMediaLabel)
            }),
        label: intl.formatMessage($c0180d8c85cbf668$var$i18n.uploadMediaLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: enableBottomSpacing ? $c0180d8c85cbf668$var$bottomSpacing : $c0180d8c85cbf668$var$removeBottomSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdToy.DefaultImagePicker), {
        contentId: contentId,
        confluencePageId: confluencePageId,
        initialUnsplashResults: defaultUnsplashResults?.slice(0, 5),
        handleImageSelection: handleImageSelection,
        imageAltText: imageAltText,
        selectedImageUrl: selectedDefaultImageUrl,
        analyticsSource: analyticsSource,
        isUploadingImage: isUploadingImage,
        isNoImageAllowed: isNoImageAllowed && !isPageTitleComponent
    })), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8fqX2.FormFieldErrorMessage), null, errorMessage)));
};

});
parcelRegister("e78Q2", function(module, exports) {

$parcel$export(module.exports, "ConfigPanelSubheading", () => $4f079bdb7e1de067$export$62d7c6d58f8d9944);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $bAts8 = parcelRequire("bAts8");
const $4f079bdb7e1de067$var$configPanelSubheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $4f079bdb7e1de067$var$configPanelSubheadingDisabledStyles = (0, $ecnYn.xcss)({
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'not-allowed'
    }
});
const $4f079bdb7e1de067$export$62d7c6d58f8d9944 = ({ children: children, showUpdatedStyles: showUpdatedStyles = false })=>{
    const isDisabled = (0, $bAts8.useIsDisabledContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $4f079bdb7e1de067$var$configPanelSubheadingStyles,
            isDisabled && $4f079bdb7e1de067$var$configPanelSubheadingDisabledStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: showUpdatedStyles ? 'medium' : 'small',
        weight: showUpdatedStyles ? 'regular' : 'bold',
        color: showUpdatedStyles ? 'color.text' : 'inherit'
    }, children));
};

});

parcelRegister("8fqX2", function(module, exports) {

$parcel$export(module.exports, "FormFieldErrorMessage", () => $dc4c02553c4c7b18$export$1834f1a788ceaae3);
/* FormFieldErrorMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $iEKnc = parcelRequire("iEKnc");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dc4c02553c4c7b18$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulp1b66 _1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $dc4c02553c4c7b18$var$ErrorText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _syaz9lu1",
            __cmplp.className
        ])
    });
});
const $dc4c02553c4c7b18$export$1834f1a788ceaae3 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($dc4c02553c4c7b18$var$ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
        label: "",
        color: "var(--ds-icon-accent-red, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($dc4c02553c4c7b18$var$ErrorText, null, children));

});

parcelRegister("aHaJw", function(module, exports) {

$parcel$export(module.exports, "useUnsplash", () => $9b94a3ced01ec057$export$d0105baa5ed279b8);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $hBkCm = parcelRequire("hBkCm");
var $8pZFw = parcelRequire("8pZFw");

var $26cuJ = parcelRequire("26cuJ");

var $io2Oj = parcelRequire("io2Oj");
const $9b94a3ced01ec057$var$i18n = (0, $2nPZH.defineMessages)({
    unsplashApiNoNetworkErrorMessage: {
        id: "custom-sites-extensions.unsplash.search.error.no-network-message",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We\u2018ve lost the connection. Try again."
    },
    unsplashApiBadStatusErrorMessage: {
        id: "custom-sites-extensions.unsplash.error.bad-request-message",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We can\u2018t get a response from Unsplash. Refresh and try again."
    },
    unsplashApiRateLimitedErrorMessage: {
        id: "custom-sites-extensions.unsplash.error.rate-limited-message",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We can\u2018t get a response from Unsplash. Wait a moment, then try again."
    }
});
var $9b94a3ced01ec057$export$d14ec7f08a14d421 = /*#__PURE__*/ function(UnsplashFetchError) {
    UnsplashFetchError["NO_NETWORK_ERROR"] = "network_error";
    UnsplashFetchError["RATE_LIMITED_ERROR"] = "rate_limited_error";
    UnsplashFetchError["BAD_STATUS_ERROR"] = "bad_status_error";
    return UnsplashFetchError;
}({});
const $9b94a3ced01ec057$var$i18nErrorText = {
    ["network_error"]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9b94a3ced01ec057$var$i18n.unsplashApiNoNetworkErrorMessage),
    ["bad_status_error"]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9b94a3ced01ec057$var$i18n.unsplashApiBadStatusErrorMessage),
    ["rate_limited_error"]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $9b94a3ced01ec057$var$i18n.unsplashApiRateLimitedErrorMessage)
};
const $9b94a3ced01ec057$export$d0105baa5ed279b8 = ({ isPageTitleComponent: isPageTitleComponent, selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults })=>{
    const [defaultUnsplashResults, setDefaultUnsplashResults] = (0, $gwFzn.useState)([]);
    const [unSplashSearchResults, setUnsplashSearchResults] = (0, $gwFzn.useState)([]);
    const [fetchError, setError] = (0, $gwFzn.useState)();
    const contentTopperDefaultImageUrl = (0, $26cuJ.isUnsplashImage)(selectedImageUrl) ? selectedImageUrl : '';
    const selectedDefaultImageUrl = !isPageTitleComponent ? selectedImageUrl : contentTopperDefaultImageUrl;
    const handleError = (0, $gwFzn.useCallback)((error)=>{
        if (error instanceof (0, $8pZFw.RateLimitedError)) setError("rate_limited_error");
        else if (error instanceof (0, $hBkCm.BadStatusError)) setError("bad_status_error");
        else setError("network_error");
        setUnsplashSearchResults(undefined);
    }, [
        setError,
        setUnsplashSearchResults
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!initialUnsplashResults) {
            const defaultUnsplashQueryWord = isPageTitleComponent ? (0, $io2Oj.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $io2Oj.CARDS_DEFAULT_UNSPLASH_QUERY_WORD);
            (0, $26cuJ.getUnsplashPhotos)(defaultUnsplashQueryWord, 1, isPageTitleComponent).then((result)=>{
                setUnsplashSearchResults(result);
                setDefaultUnsplashResults(result);
            }).catch((responseError)=>{
                handleError(responseError);
            });
        } else {
            setUnsplashSearchResults(initialUnsplashResults);
            setDefaultUnsplashResults(initialUnsplashResults);
        }
    }, [
        initialUnsplashResults,
        isPageTitleComponent,
        handleError
    ]);
    return {
        selectedDefaultImageUrl: selectedDefaultImageUrl,
        defaultUnsplashResults: defaultUnsplashResults,
        unSplashSearchResults: unSplashSearchResults,
        errorMessage: fetchError ? $9b94a3ced01ec057$var$i18nErrorText[fetchError] : undefined,
        handleError: handleError,
        setUnsplashSearchResults: setUnsplashSearchResults,
        setDefaultUnsplashResults: setDefaultUnsplashResults,
        setError: setError
    };
};

});

parcelRegister("5xYQE", function(module, exports) {

$parcel$export(module.exports, "UnsplashSearchBar", () => $24165581ab9f3adb$export$a7e261e3ec8ef2a0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2jjxD = parcelRequire("2jjxD");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $jluld = parcelRequire("jluld");

var $lGgRw = parcelRequire("lGgRw");

var $4noo5 = parcelRequire("4noo5");

var $inPa6 = parcelRequire("inPa6");

var $bAts8 = parcelRequire("bAts8");

var $26cuJ = parcelRequire("26cuJ");

var $io2Oj = parcelRequire("io2Oj");
const $24165581ab9f3adb$var$i18n = (0, $2nPZH.defineMessages)({
    refinedUnsplashSearchPlaceholderText: {
        id: "custom-sites-extensions.refined.unsplash.search.placeholder",
        defaultMessage: "Browse Unsplash"
    },
    unsplashLoadMoreText: {
        id: "custom-sites-extensions.unsplash.search.load.more.unsplash.photos",
        defaultMessage: "Load more"
    }
});
const $24165581ab9f3adb$var$iconContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
const $24165581ab9f3adb$export$a7e261e3ec8ef2a0 = ({ elementIdPrefix: elementIdPrefix, unsplashSearchFieldId: unsplashSearchFieldId, handleImageSelection: handleImageSelection, dropdownPopupComponentRef: dropdownPopupComponentRef, placement: placement = 'bottom', analyticsSource: analyticsSource, isPageTitleComponent: isPageTitleComponent = false, isUploadingImage: isUploadingImage = false, defaultUnsplashResults: defaultUnsplashResults, setDefaultUnsplashResults: setDefaultUnsplashResults, unSplashSearchResults: unSplashSearchResults, setUnsplashSearchResults: setUnsplashSearchResults, setError: setError, handleError: handleError })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isDisabled = (0, $bAts8.useIsDisabledContext)();
    const [isPopupOpen, setIsPopupOpen] = (0, $gwFzn.useState)(false);
    const [unsplashResultsCountFromLastAPICall, setUnsplashResultsCountFromLastAPICall] = (0, $gwFzn.useState)(30);
    const searchResultsRef = (0, $gwFzn.useRef)(null);
    const pageNumber = (0, $gwFzn.useRef)(1);
    const textfieldInputValue = (0, $gwFzn.useRef)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const debouncedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))((searchBar)=>{
        textfieldInputValue.current = searchBar?.value;
        const defaultQueryWord = isPageTitleComponent ? (0, $io2Oj.PAGE_TITLE_DEFAULT_UNSPLASH_QUERY_WORD) : (0, $io2Oj.CARDS_DEFAULT_UNSPLASH_QUERY_WORD);
        const queryKeyword = textfieldInputValue.current || defaultQueryWord;
        setUnsplashSearchResults(Array(30).fill(null));
        (0, $26cuJ.getUnsplashPhotos)(queryKeyword, pageNumber.current, isPageTitleComponent).then((result)=>{
            if (!defaultUnsplashResults || defaultUnsplashResults.length === 0) setDefaultUnsplashResults(result);
            setUnsplashResultsCountFromLastAPICall(result.length);
            setUnsplashSearchResults(result);
            setError(undefined);
        }).catch((error)=>{
            handleError(error);
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'typed',
                actionSubject: 'headerImageSearch',
                actionSubjectId: 'headerImageSearchTyped',
                source: analyticsSource
            }
        }).fire();
    }, 350);
    const handleSearchOnChange = (event)=>{
        pageNumber.current = 1;
        debouncedQuery(event.target);
        searchResultsRef.current?.scroll({
            top: 0,
            behavior: 'smooth'
        });
    };
    const handleChange = ()=>{
        setIsPopupOpen(true);
    };
    const handleKeyDown = (event)=>{
        if ([
            'Enter',
            ' ',
            'ArrowUp',
            'ArrowDown'
        ].includes(event.key)) {
            if (event.key === ' ' && !textfieldInputValue.current) event.preventDefault();
            handleChange();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: false,
        onClose: ()=>setIsPopupOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $io2Oj.UnsplashSearchContent), {
                dropdownPopupComponentRef: dropdownPopupComponentRef,
                unSplashSearchResults: unSplashSearchResults,
                idPrefix: elementIdPrefix,
                handleImageSelection: handleImageSelection,
                loadMoreText: $24165581ab9f3adb$var$i18n.unsplashLoadMoreText,
                queryWord: textfieldInputValue,
                pageNumber: pageNumber,
                setUnsplashSearchResults: setUnsplashSearchResults,
                handleError: handleError,
                searchResultsRef: searchResultsRef,
                unsplashResultsCountFromLastAPICall: unsplashResultsCountFromLastAPICall,
                setUnsplashResultsCountFromLastAPICall: setUnsplashResultsCountFromLastAPICall,
                isPageTitleComponent: isPageTitleComponent,
                analyticsSource: analyticsSource
            }),
        isOpen: isPopupOpen,
        placement: placement,
        testId: "unsplash-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
                ...triggerProps,
                id: unsplashSearchFieldId,
                testId: `${elementIdPrefix}-unsplash-search-bar`,
                onChange: handleSearchOnChange,
                onClick: handleChange,
                onInput: handleChange,
                onKeyDown: (event)=>handleKeyDown(event),
                isDisabled: isUploadingImage || isDisabled,
                elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    xcss: $24165581ab9f3adb$var$iconContainerStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    label: "search",
                    color: "currentColor"
                })),
                placeholder: formatMessage($24165581ab9f3adb$var$i18n.refinedUnsplashSearchPlaceholderText)
            })
    });
};

});

parcelRegister("93SjD", function(module, exports) {

$parcel$export(module.exports, "MediaContentHelperMessage", () => $e270c20a1292bb3b$export$f3270c9ea239a57e);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $gQhRa = parcelRequire("gQhRa");
const $e270c20a1292bb3b$var$helperMessageWrapperStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100',
    display: 'flex',
    justifyContent: 'space-between'
});
const $e270c20a1292bb3b$var$helperMessageDisabledStyles = (0, $ecnYn.xcss)({
    color: 'color.text.disabled'
});
const $e270c20a1292bb3b$export$f3270c9ea239a57e = ({ helperMessage: helperMessage, isDisabled: isDisabled })=>helperMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $e270c20a1292bb3b$var$helperMessageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isDisabled ? $e270c20a1292bb3b$var$helperMessageDisabledStyles : undefined
    }, helperMessage))) : null;

});

parcelRegister("gdToy", function(module, exports) {

$parcel$export(module.exports, "ThumbnailType", () => $0da3be1324e23cd3$export$bc1779d8140a60be);
$parcel$export(module.exports, "DefaultImagePicker", () => $0da3be1324e23cd3$export$62a2f85610ce8d51);

var $gwFzn = parcelRequire("gwFzn");

var $7FcUt = parcelRequire("7FcUt");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $bAts8 = parcelRequire("bAts8");

var $lQkOO = parcelRequire("lQkOO");

var $e3cww = parcelRequire("e3cww");

var $7Yq9J = parcelRequire("7Yq9J");

var $4ERqK = parcelRequire("4ERqK");

var $68Le1 = parcelRequire("68Le1");

var $3Y5jN = parcelRequire("3Y5jN");
const $0da3be1324e23cd3$var$ImagesWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    justifyContent: 'space-between',
    paddingTop: 'space.0'
});
const $0da3be1324e23cd3$var$selectedImageTickStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: 'space.0',
    right: 'space.0',
    '::before': {
        content: '""',
        backgroundColor: 'elevation.surface',
        height: '50%',
        width: '50%',
        position: 'absolute',
        right: 'space.050',
        top: 'space.050'
    }
});
const $0da3be1324e23cd3$var$checkboxWrapperStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
var $0da3be1324e23cd3$export$bc1779d8140a60be = /*#__PURE__*/ function(ThumbnailType) {
    ThumbnailType[ThumbnailType["UNSPLASH_DEFAULT_IMAGE"] = 0] = "UNSPLASH_DEFAULT_IMAGE";
    ThumbnailType[ThumbnailType["UNSPLASH_IMAGE"] = 1] = "UNSPLASH_IMAGE";
    ThumbnailType[ThumbnailType["CUSTOM_IMAGE"] = 2] = "CUSTOM_IMAGE";
    ThumbnailType[ThumbnailType["EXTERNAL_SITE_IMAGE"] = 3] = "EXTERNAL_SITE_IMAGE";
    ThumbnailType[ThumbnailType["NO_IMAGE"] = 4] = "NO_IMAGE";
    return ThumbnailType;
}({});
const $0da3be1324e23cd3$var$isUnsplashDefaultImageThumbnail = (thumbnail)=>{
    return thumbnail.type === 0;
};
const $0da3be1324e23cd3$var$isUnsplashImageThumbnail = (thumbnail)=>{
    return thumbnail.type === 1;
};
const $0da3be1324e23cd3$var$isCustomImageThumbnail = (thumbnail)=>{
    return thumbnail.type === 2;
};
const $0da3be1324e23cd3$var$isExternalSiteImageThumbnail = (thumbnail)=>{
    return thumbnail.type === 3;
};
const $0da3be1324e23cd3$var$isNoImageThumbnail = (thumbnail)=>{
    return thumbnail.type === 4;
};
const $0da3be1324e23cd3$var$createNoImageThumbnail = ()=>({
        type: 4,
        image: undefined
    });
const $0da3be1324e23cd3$export$71256286fd384466 = ()=>{
    return Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e3cww.PlaceholderThumbnail), {
            key: index
        }));
};
const $0da3be1324e23cd3$export$62a2f85610ce8d51 = ({ contentId: contentId, imageAltText: imageAltText, selectedImageUrl: selectedImageUrl, handleImageSelection: handleImageSelection, initialUnsplashResults: initialUnsplashResults, analyticsSource: analyticsSource, isUploadingImage: isUploadingImage, isNoImageAllowed: isNoImageAllowed, initialUploadedImageId: initialUploadedImageId, previewUploadedImageId: previewUploadedImageId })=>{
    const isDisabled = (0, $bAts8.useIsDisabledContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onImageClick = (0, $gwFzn.useCallback)(({ fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink })=>{
        if (!isUploadingImage) {
            handleImageSelection({
                fullSizeImageUrl: fullSizeImageUrl,
                altDescription: altDescription,
                downloadLink: downloadLink
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'image',
                    source: analyticsSource,
                    attributes: {
                        imageSource: 'unsplashDefault'
                    }
                }
            }).fire();
        }
    }, [
        analyticsSource,
        createAnalyticsEvent,
        handleImageSelection,
        isUploadingImage
    ]);
    const renderCheckboxIcon = (0, $gwFzn.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $0da3be1324e23cd3$var$selectedImageTickStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            xcss: $0da3be1324e23cd3$var$checkboxWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7FcUt))), {
            label: "checkmark",
            color: "var(--ds-icon-brand, #0C66E4)"
        })));
    }, []);
    const renderGenericUnsplashImage = (0, $gwFzn.useCallback)(({ smallSizeImageUrl: smallSizeImageUrl, fullSizeImageUrl: fullSizeImageUrl, downloadLink: downloadLink, description: description, isSelected: isSelected, index: index })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lQkOO.UnsplashImageThumbnail), {
            key: `thumbnail-${index}`,
            image: smallSizeImageUrl,
            description: description,
            isSelected: isSelected,
            canBeSelected: isUploadingImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: fullSizeImageUrl,
                    altDescription: description,
                    downloadLink: downloadLink
                })
        }, isSelected && renderCheckboxIcon());
    }, [
        isUploadingImage,
        onImageClick,
        renderCheckboxIcon
    ]);
    const renderUnsplashDefaultImage = (0, $gwFzn.useCallback)((image, index)=>{
        const { fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription, downloadLink: downloadLink, smallSizeImageUrl: smallSizeImageUrl } = image;
        const isSelected = fullSizeImageUrl === selectedImageUrl;
        return renderGenericUnsplashImage({
            smallSizeImageUrl: smallSizeImageUrl ?? fullSizeImageUrl,
            fullSizeImageUrl: fullSizeImageUrl,
            description: altDescription,
            downloadLink: downloadLink,
            isSelected: isSelected,
            index: index
        });
    }, [
        selectedImageUrl,
        renderGenericUnsplashImage
    ]);
    const renderUnsplashImage = (0, $gwFzn.useCallback)((image, index)=>{
        const { fullSizeImageUrl: fullSizeImageUrl, altDescription: altDescription } = image;
        const isSelected = fullSizeImageUrl === selectedImageUrl;
        return renderGenericUnsplashImage({
            smallSizeImageUrl: fullSizeImageUrl,
            fullSizeImageUrl: fullSizeImageUrl,
            description: altDescription ?? '',
            downloadLink: undefined,
            isSelected: isSelected,
            index: index
        });
    }, [
        selectedImageUrl,
        renderGenericUnsplashImage
    ]);
    const renderExternalSiteImage = (0, $gwFzn.useCallback)((image, index)=>{
        const isSelectedImage = image === selectedImageUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $68Le1.ExternalSiteImageThumbnail), {
            key: `thumbnail-${index}`,
            image: image,
            isSelected: isSelectedImage,
            canBeSelected: isUploadingImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: image,
                    altDescription: ''
                })
        }, isSelectedImage && renderCheckboxIcon());
    }, [
        selectedImageUrl,
        isUploadingImage,
        renderCheckboxIcon,
        onImageClick
    ]);
    const renderUploadedImage = (0, $gwFzn.useCallback)((image, index)=>{
        const { imageId: imageId } = image;
        const isSelectedImage = imageId === selectedImageUrl && index === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Yq9J.UploadedImageThumbnail), {
            key: `thumbnail-${index}`,
            contentId: contentId,
            imageId: imageId,
            isSelected: isSelectedImage,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: imageId,
                    altDescription: ''
                })
        }, isSelectedImage && renderCheckboxIcon());
    }, [
        selectedImageUrl,
        contentId,
        onImageClick,
        renderCheckboxIcon
    ]);
    const renderNoImageThumbnail = (0, $gwFzn.useCallback)((index)=>{
        const isSelected = selectedImageUrl === '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4ERqK.NoImageThumbnail), {
            key: index,
            isSelected: isSelected,
            onClick: ()=>onImageClick({
                    fullSizeImageUrl: '',
                    altDescription: ''
                })
        }, isSelected && renderCheckboxIcon());
    }, [
        selectedImageUrl,
        onImageClick,
        renderCheckboxIcon
    ]);
    const firstImage = (0, $gwFzn.useRef)();
    firstImage.current = (0, $3Y5jN.getFirstImage)({
        selectedImageUrl: selectedImageUrl,
        initialUnsplashResults: initialUnsplashResults,
        isNoImageAllowed: isNoImageAllowed,
        firstImage: firstImage,
        previewUploadedImageId: previewUploadedImageId,
        initialUploadedImageId: initialUploadedImageId,
        imageAltText: imageAltText
    });
    const secondImage = isNoImageAllowed ? $0da3be1324e23cd3$var$createNoImageThumbnail() : (0, $3Y5jN.createUnsplashDefaultImageThumbnail)(initialUnsplashResults?.[1]);
    const imagesToDisplay = [
        firstImage.current,
        secondImage,
        (0, $3Y5jN.createUnsplashDefaultImageThumbnail)(initialUnsplashResults?.[2]),
        (0, $3Y5jN.createUnsplashDefaultImageThumbnail)(initialUnsplashResults?.[3]),
        (0, $3Y5jN.createUnsplashDefaultImageThumbnail)(initialUnsplashResults?.[4])
    ];
    const renderThumbnails = (0, $gwFzn.useCallback)((thumbnail, index)=>{
        // Ordering matters for first image rendering logic
        if ($0da3be1324e23cd3$var$isNoImageThumbnail(thumbnail)) return renderNoImageThumbnail(index);
        if (!thumbnail.image) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e3cww.PlaceholderThumbnail), {
            key: index
        });
        if ($0da3be1324e23cd3$var$isUnsplashDefaultImageThumbnail(thumbnail)) return renderUnsplashDefaultImage(thumbnail.image, index);
        if ($0da3be1324e23cd3$var$isUnsplashImageThumbnail(thumbnail)) return renderUnsplashImage(thumbnail.image, index);
        if ($0da3be1324e23cd3$var$isExternalSiteImageThumbnail(thumbnail)) return renderExternalSiteImage(thumbnail.image, index);
        if ($0da3be1324e23cd3$var$isCustomImageThumbnail(thumbnail)) return renderUploadedImage(thumbnail.image, index);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e3cww.PlaceholderThumbnail), {
            key: index
        });
    }, [
        renderNoImageThumbnail,
        renderUnsplashDefaultImage,
        renderUnsplashImage,
        renderUploadedImage,
        renderExternalSiteImage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $0da3be1324e23cd3$var$ImagesWrapperStyles,
        testId: "default-image-picker"
    }, isDisabled ? $0da3be1324e23cd3$export$71256286fd384466() : imagesToDisplay.map(renderThumbnails));
};

});
parcelRegister("lQkOO", function(module, exports) {

$parcel$export(module.exports, "UnsplashImageThumbnail", () => $c6b5cbbb00262ca6$export$99fc49c7c3f55eda);

var $gwFzn = parcelRequire("gwFzn");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");
const $c6b5cbbb00262ca6$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'border.radius.100',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $c6b5cbbb00262ca6$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
});
const $c6b5cbbb00262ca6$var$canBeSelectedStyles = (0, $ecnYn.xcss)({
    cursor: 'auto'
});
const $c6b5cbbb00262ca6$export$99fc49c7c3f55eda = ({ image: image, description: description, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        // rerender when isSelected is changed to fix the issue when the component was not updated
        key: `${image} ${isSelected ? '1' : '0'}`,
        "aria-pressed": isSelected,
        "aria-label": description,
        xcss: [
            $c6b5cbbb00262ca6$var$baseStyles,
            canBeSelected && $c6b5cbbb00262ca6$var$canBeSelectedStyles,
            isSelected && $c6b5cbbb00262ca6$var$selectedStyles
        ],
        style: {
            backgroundImage: `url(${image})`
        },
        onClick: onClick
    }, children);
};

});

parcelRegister("e3cww", function(module, exports) {

$parcel$export(module.exports, "PlaceholderThumbnail", () => $7ac821a560f64a6b$export$e327f3d4c8672489);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $7ac821a560f64a6b$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'border.radius.100',
    border: 'none'
});
const $7ac821a560f64a6b$var$placeholderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $7ac821a560f64a6b$export$e327f3d4c8672489 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $7ac821a560f64a6b$var$baseStyles,
            $7ac821a560f64a6b$var$placeholderStyles
        ],
        testId: "image-picker-placeholders"
    });
};

});

parcelRegister("7Yq9J", function(module, exports) {

$parcel$export(module.exports, "UploadedImageThumbnail", () => $e24319a489fc9775$export$94984c14ad3e5368);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $3rvSa = parcelRequire("3rvSa");

var $inPa6 = parcelRequire("inPa6");

var $btHGY = parcelRequire("btHGY");

var $7aRa9 = parcelRequire("7aRa9");

var $4IoVL = parcelRequire("4IoVL");

var $e3cww = parcelRequire("e3cww");
const $e24319a489fc9775$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'border.radius.100',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $e24319a489fc9775$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
});
const $e24319a489fc9775$var$i18n = (0, $2nPZH.defineMessages)({
    uploadImageFailedDescription: {
        id: "custom-sites-extensions.shared-components.unsplash-search.upload.error.description",
        defaultMessage: "Refresh the page and try again"
    },
    uploadImageFailedTitle: {
        id: "custom-sites-extensions.shared-components.unsplash-search.upload.error.title",
        defaultMessage: "Image failed to load"
    }
});
const $e24319a489fc9775$var$getImageMediaLocation = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $e24319a489fc9775$var$UploadedImageThumbnailComponent = ({ contentId: contentId, imageId: maybeCustomCoverImage, isSelected: isSelected, onClick: onClick, flags: flags, children: children })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [mediaConfig, setMediaConfig] = (0, $gwFzn.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [collectionId, imageId] = $e24319a489fc9775$var$getImageMediaLocation(contentId, maybeCustomCoverImage);
    // Setup media config
    (0, $gwFzn.useEffect)(()=>{
        const createMediaConfig = async ()=>{
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: collectionId,
                isExternalShare: false
            });
            if (viewMediaClientConfig == undefined) return null;
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider
            });
        };
        createMediaConfig();
    }, [
        collectionId
    ]);
    if (!mediaConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e3cww.PlaceholderThumbnail), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3rvSa.MediaClientProvider), {
        clientConfig: mediaConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
        identifier: {
            mediaItemType: 'file',
            id: imageId,
            collectionName: mediaConfig.collection
        },
        //force rerender image on id change until https://product-fabric.atlassian.net/browse/CXP-2899 is fixed
        key: imageId,
        mediaClientConfig: {
            authProvider: mediaConfig.authProvider
        },
        apiConfig: {
            allowAnimated: true,
            mode: 'full-fit',
            upscale: false
        }
    }, ({ data: data, loading: loading, error: error })=>{
        if (loading || !data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e3cww.PlaceholderThumbnail), null);
        if (error) {
            flags.showErrorFlag({
                id: 'upload-image-error',
                title: formatMessage($e24319a489fc9775$var$i18n.uploadImageFailedTitle),
                description: formatMessage($e24319a489fc9775$var$i18n.uploadImageFailedDescription)
            });
            createAnalyticsEvent({
                type: 'error',
                data: {
                    actionSubject: 'image',
                    actionSubjectId: 'coverImageSelected',
                    source: 'coverImageSelectedComponent'
                }
            }).fire();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e3cww.PlaceholderThumbnail), null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
            xcss: [
                $e24319a489fc9775$var$baseStyles,
                isSelected && $e24319a489fc9775$var$selectedStyles
            ],
            style: {
                backgroundImage: `url(${data.src})`
            },
            onClick: onClick,
            testId: "uploaded-image-thumbnail"
        }, children);
    }));
};
const $e24319a489fc9775$export$94984c14ad3e5368 = (0, $7aRa9.withFlags)($e24319a489fc9775$var$UploadedImageThumbnailComponent);

});

parcelRegister("4ERqK", function(module, exports) {

$parcel$export(module.exports, "NoImageThumbnail", () => $8fe7dddd343b5931$export$8b9fdf0a6bb637af);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");
const $8fe7dddd343b5931$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'border.radius.100',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative'
});
const $8fe7dddd343b5931$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
});
const $8fe7dddd343b5931$var$noImageStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 1px ${"var(--ds-border, #091E4224)"}`,
    position: 'relative'
});
const $8fe7dddd343b5931$var$noImageLineStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: '50%',
    top: '5%',
    height: '90%',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'color.border',
    rotate: '45deg'
});
const $8fe7dddd343b5931$var$i18n = (0, $2nPZH.defineMessages)({
    noImageLabel: {
        id: "custom-sites-extensions.unsplash-search.default-image-picker.no-image",
        defaultMessage: "No image"
    }
});
const $8fe7dddd343b5931$export$8b9fdf0a6bb637af = ({ onClick: onClick, isSelected: isSelected, children: children })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        xcss: [
            $8fe7dddd343b5931$var$baseStyles,
            $8fe7dddd343b5931$var$noImageStyles,
            isSelected && $8fe7dddd343b5931$var$selectedStyles
        ],
        testId: "unsplash-no-image",
        "aria-label": intl.formatMessage($8fe7dddd343b5931$var$i18n.noImageLabel),
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8fe7dddd343b5931$var$noImageLineStyles
    }), children);
};

});

parcelRegister("68Le1", function(module, exports) {

$parcel$export(module.exports, "ExternalSiteImageThumbnail", () => $3831925e86cc6d24$export$58ac8acf6266d241);

var $gwFzn = parcelRequire("gwFzn");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");
const $3831925e86cc6d24$var$baseStyles = (0, $ecnYn.xcss)({
    height: '40px',
    width: '44px',
    borderRadius: 'border.radius.100',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
});
const $3831925e86cc6d24$var$selectedStyles = (0, $ecnYn.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `inset 0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
});
const $3831925e86cc6d24$var$canBeSelectedStyles = (0, $ecnYn.xcss)({
    cursor: 'auto'
});
const $3831925e86cc6d24$export$58ac8acf6266d241 = ({ image: image, isSelected: isSelected, canBeSelected: canBeSelected, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        // rerender when isSelected is changed to fix the issue when the component was not updated
        key: `${image} ${isSelected ? '1' : '0'}`,
        "aria-pressed": isSelected,
        xcss: [
            $3831925e86cc6d24$var$baseStyles,
            canBeSelected && $3831925e86cc6d24$var$canBeSelectedStyles,
            isSelected && $3831925e86cc6d24$var$selectedStyles
        ],
        style: {
            backgroundImage: `url(${image})`
        },
        onClick: onClick
    }, children);
};

});

parcelRegister("3Y5jN", function(module, exports) {

$parcel$export(module.exports, "createUnsplashDefaultImageThumbnail", () => $fd3d4a164293ba5f$export$7f2b17edc08bf65b);
$parcel$export(module.exports, "getFirstImage", () => $fd3d4a164293ba5f$export$e3511fb9079c14da);

var $26cuJ = parcelRequire("26cuJ");

var $gdToy = parcelRequire("gdToy");
const $fd3d4a164293ba5f$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $fd3d4a164293ba5f$var$createCustomImageThumbnail = (imageId)=>({
        type: (0, $gdToy.ThumbnailType).CUSTOM_IMAGE,
        image: {
            imageId: imageId
        }
    });
const $fd3d4a164293ba5f$export$7f2b17edc08bf65b = (image)=>({
        type: (0, $gdToy.ThumbnailType).UNSPLASH_DEFAULT_IMAGE,
        image: image
    });
const $fd3d4a164293ba5f$var$createUnsplashImageThumbnail = (url, altText)=>({
        type: (0, $gdToy.ThumbnailType).UNSPLASH_IMAGE,
        image: {
            fullSizeImageUrl: url,
            altDescription: altText
        }
    });
const $fd3d4a164293ba5f$var$createExternalSiteImageThumbnail = (url)=>({
        type: (0, $gdToy.ThumbnailType).EXTERNAL_SITE_IMAGE,
        image: url
    });
const $fd3d4a164293ba5f$var$initialUnsplashResultsIncludes = ({ image: image, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed })=>{
    if (!initialUnsplashResults?.length) return false;
    const adjustedUnsplashResults = isNoImageAllowed ? initialUnsplashResults.toSpliced(0, 2) : initialUnsplashResults.toSpliced(0, 1);
    return adjustedUnsplashResults.map((result)=>result.fullSizeImageUrl).includes(image || '');
};
const $fd3d4a164293ba5f$var$getFirstImageWhenSelectedImageIsUnsplash = ({ selectedImageUrl: selectedImageUrl, firstImage: firstImage, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, previewUploadedImageId: previewUploadedImageId, initialUploadedImageId: initialUploadedImageId, imageAltText: imageAltText })=>{
    const isSelectedUnsplashInInitialResults = (image = selectedImageUrl)=>$fd3d4a164293ba5f$var$initialUnsplashResultsIncludes({
            image: image,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: isNoImageAllowed
        });
    // if selected unsplash image is not in initial results array, then it should always be in the
    // first thumbnail
    if (!isSelectedUnsplashInInitialResults()) return $fd3d4a164293ba5f$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    // TODO: this code can be removed when UnsplashSearch is replaced by MediaPickerContent
    const currentFirstImageUnsplash = firstImage?.current?.image && typeof firstImage?.current?.image !== 'string' && 'fullSizeImageUrl' in firstImage.current.image && (0, $26cuJ.isUnsplashImage)(firstImage.current.image.fullSizeImageUrl) && firstImage?.current?.image?.fullSizeImageUrl;
    if (currentFirstImageUnsplash && selectedImageUrl !== currentFirstImageUnsplash) {
        if (!isSelectedUnsplashInInitialResults(currentFirstImageUnsplash) && isSelectedUnsplashInInitialResults()) return $fd3d4a164293ba5f$var$createUnsplashImageThumbnail(currentFirstImageUnsplash, imageAltText);
        if (!isSelectedUnsplashInInitialResults()) return $fd3d4a164293ba5f$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    }
    if (previewUploadedImageId && firstImage.current?.image === previewUploadedImageId) {
        if (isSelectedUnsplashInInitialResults()) return firstImage.current;
        if (!isSelectedUnsplashInInitialResults()) return $fd3d4a164293ba5f$var$createUnsplashImageThumbnail(selectedImageUrl, imageAltText);
    }
    if (firstImage?.current?.image && typeof firstImage.current.image !== 'string' && 'imageId' in firstImage.current.image && isSelectedUnsplashInInitialResults()) return firstImage.current;
    if (isSelectedUnsplashInInitialResults() && previewUploadedImageId && initialUploadedImageId) return $fd3d4a164293ba5f$var$createCustomImageThumbnail(previewUploadedImageId);
    if (isSelectedUnsplashInInitialResults() && previewUploadedImageId) return $fd3d4a164293ba5f$var$createCustomImageThumbnail(previewUploadedImageId);
    if (isSelectedUnsplashInInitialResults() && initialUnsplashResults?.length) return $fd3d4a164293ba5f$export$7f2b17edc08bf65b(initialUnsplashResults[0]);
    return $fd3d4a164293ba5f$export$7f2b17edc08bf65b();
};
const $fd3d4a164293ba5f$export$e3511fb9079c14da = ({ selectedImageUrl: selectedImageUrl, initialUnsplashResults: initialUnsplashResults, isNoImageAllowed: isNoImageAllowed, firstImage: firstImage, previewUploadedImageId: previewUploadedImageId, initialUploadedImageId: initialUploadedImageId, imageAltText: imageAltText })=>{
    if (selectedImageUrl) {
        if ((0, $26cuJ.isUnsplashImage)(selectedImageUrl)) return $fd3d4a164293ba5f$var$getFirstImageWhenSelectedImageIsUnsplash({
            selectedImageUrl: selectedImageUrl,
            firstImage: firstImage,
            initialUnsplashResults: initialUnsplashResults,
            isNoImageAllowed: isNoImageAllowed,
            previewUploadedImageId: previewUploadedImageId,
            initialUploadedImageId: initialUploadedImageId,
            imageAltText: imageAltText
        });
        else {
            if ($fd3d4a164293ba5f$var$externalSiteMatcher.test(selectedImageUrl)) return $fd3d4a164293ba5f$var$createExternalSiteImageThumbnail(selectedImageUrl);
            return $fd3d4a164293ba5f$var$createCustomImageThumbnail(selectedImageUrl);
        }
    }
    if (initialUploadedImageId) return $fd3d4a164293ba5f$var$createCustomImageThumbnail(initialUploadedImageId);
    if (initialUnsplashResults?.length) return $fd3d4a164293ba5f$export$7f2b17edc08bf65b(initialUnsplashResults[0]);
    return $fd3d4a164293ba5f$export$7f2b17edc08bf65b();
};

});




//# sourceMappingURL=EditorPageCoverPicture.63590c19.js.map
